/*
 * Above 9 · Tranquitone · the gift note's character counter (original work, theme v0.2.1, 2026-10-04;
 * DECISIONS.md row 32).
 *
 * Shows "<typed>/<most>" under the gift note and follows every keystroke. It renders only when Theme settings > Cart >
 * "Gift note: most characters" is set; the textarea then carries the same maxlength, so the counter counts what the
 * browser counts (UTF-16 code units). The element is skipped by Horizon's section morph (data-skip-node-update), as
 * the textarea is, so a cart re-render never resets it while someone types. It is the textarea's description
 * (aria-describedby), read when the field takes focus, and not a live region, so it never speaks on every key.
 */

class A9NoteCount extends HTMLElement {
  connectedCallback() {
    this.max = Number(this.dataset.max) || 0;
    this.field = /** @type {HTMLTextAreaElement | null} */ (
      this.closest('.cart-note__inner')?.querySelector('textarea[name="note"]') ?? null
    );
    this.onInput = () => this.update();
    this.field?.addEventListener('input', this.onInput);
    this.update();
  }

  disconnectedCallback() {
    if (this.field && this.onInput) this.field.removeEventListener('input', this.onInput);
  }

  update() {
    if (!this.field || !this.max) return;
    const typed = this.field.value.length;
    this.textContent = `${typed}/${this.max}`;
    this.classList.toggle('is-full', typed >= this.max);
  }
}

if (!customElements.get('a9-note-count')) customElements.define('a9-note-count', A9NoteCount);
